module.exports = __webpack_public_path__ + "d5c01c2ae4fbf44571e51aa38e1a9fe9.svg";